import { render, staticRenderFns } from "./LocalYellowWaveMain.vue?vue&type=template&id=8fd73820&scoped=true"
import script from "./LocalYellowWaveMain.vue?vue&type=script&lang=js"
export * from "./LocalYellowWaveMain.vue?vue&type=script&lang=js"
import style0 from "./LocalYellowWaveMain.vue?vue&type=style&index=0&id=8fd73820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd73820",
  null
  
)

export default component.exports